import { render, staticRenderFns } from "./-Header.vue?vue&type=template&id=80f21c7e&scoped=true&"
import script from "./-Header.vue?vue&type=script&lang=js&"
export * from "./-Header.vue?vue&type=script&lang=js&"
import style0 from "./-Header.vue?vue&type=style&index=0&id=80f21c7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f21c7e",
  null
  
)

export default component.exports